import { useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';

import {
    Box, Button, FormControl, FormLabel, Input, Stack, Text, useToast,
} from '@chakra-ui/react';

import { useAuth } from '../contexts/AuthContext';

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const { resetPassword } = useAuth();
  const toast = useToast();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsLoading(true);

    try {
      await resetPassword(email);
      toast({
        title: "Success",
        description: "Password reset instructions have been sent to your email",
        status: "success",
        duration: 3000,
        isClosable: true,
      });
    } catch (error) {
      toast({
        title: "Error",
        description:
          error instanceof Error
            ? error.message
            : "Failed to send reset instructions",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Box minH="100vh" py={12} px={{ base: 4, sm: 6, lg: 8 }}>
      <Box maxW="md" mx="auto">
        <Stack spacing={8}>
          <Stack spacing={6}>
            <Stack spacing={3} textAlign="center">
              <Text fontSize="3xl" fontWeight="bold">
                Reset your password
              </Text>
              <Text color="gray.600">
                Enter your email address and we'll send you instructions to
                reset your password
              </Text>
            </Stack>
          </Stack>

          <Box
            py={8}
            px={4}
            shadow="base"
            rounded="lg"
            bg="white"
            _dark={{ bg: "gray.700" }}
          >
            <form onSubmit={handleSubmit}>
              <Stack spacing={6}>
                <FormControl id="email">
                  <FormLabel>Email address</FormLabel>
                  <Input
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                  />
                </FormControl>

                <Button
                  type="submit"
                  colorScheme="blue"
                  size="lg"
                  fontSize="md"
                  isLoading={isLoading}
                >
                  Send Reset Instructions
                </Button>

                <Text textAlign="center">
                  Remember your password?{" "}
                  <RouterLink to="/login" style={{ color: "blue" }}>
                    Sign in
                  </RouterLink>
                </Text>
              </Stack>
            </form>
          </Box>
        </Stack>
      </Box>
    </Box>
  );
}
